import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";

import {
  AcsTokenSuccessResponse,
  AcsTokenErrorResponse,
  AcsToken,
  AcsTokenError,
} from "../../acs-service-provider/services/acsToken.types";
import {
  ACS_SERVICE_TOKEN_PATH,
  ACS_SERVICE_BASE_URL,
} from "../../../environments/environment";
import { ACS_TOKEN_API_TIMEOUT } from "../../../shared/apiConstants";
import { validateAcsToken } from "../../../utils/data-validation/validateAcsToken";

import { IAPIService } from "./Service.types";

export class APIService implements IAPIService {
  private readonly apiHandler: AxiosInstance;

  constructor(tenantId: string | undefined) {
    const apiParams = {
      Tid: tenantId,
    };
    this.apiHandler = axios.create({
      baseURL: ACS_SERVICE_BASE_URL,
      withCredentials: false,
      headers: {
        "Content-Type": "application/json",
      },
      params: apiParams,
    });
  }

  // Handle getToken API response and validate data received
  private handleResponse = (
    response: AxiosResponse<AcsTokenSuccessResponse, "json">
  ): Promise<AcsToken> => {
    return Promise.resolve({
      token: validateAcsToken(response.data.token),
      acsEndpoint: response.data.acsEndpoint,
      region: response.data.region,
    });
  };

  // Handle getToken API errors
  private handleError = (
    error: AxiosError<AcsTokenErrorResponse, "json">
  ): Promise<AcsTokenError> => {
    return Promise.resolve({
      isError: true,
      message: error.response?.data?.Errors[0].Message,
      status: error.response?.data?.Errors[0].StatusCode,
    });
  };

  public async getACSToken(): Promise<AcsToken | AcsTokenError> {
    return this.apiHandler
      .get<AcsTokenSuccessResponse>(ACS_SERVICE_TOKEN_PATH, {
        timeout: ACS_TOKEN_API_TIMEOUT,
      })
      .then(this.handleResponse)
      .catch(this.handleError);
  }
}
